import React from 'react'
import { ClaroModalCustom, ClaroCardSimple } from "@claropay/shared";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PaymentMethodsList from '../../../molecules/SelectCardAnonimous/PaymentMethodsList';
import AddCardForm from '../../../molecules/SelectCardAnonimous/AddCardForm';
import { executeTaggeo, setAddCardFormData } from '../../../../store/actions';

const SelectCardAnonimous = (props) => {

	const sendTaggeoBack = () => {
		props.executeTaggeo({
			step: "Formulario de pago",
			action: "Click modal Back",
			modal_id: "Ingresa una tarjeta"
		});
	}

	const sendTaggeoClose = () => {
		props.executeTaggeo({
			step: "Formulario de pago",
			action: "Click modal Cerrar",
			modal_id: props.addCardFormData.isOpenAddCardForm ? "Ingresa una tarjeta" : "Elige método de pago"
		});
	}

	const cleanAddCardFormData = () => {
		props.setAddCardFormData({ 
			...props.addCardFormData,
			creditCardNumberValue: undefined,
			cvvValue: undefined,
			expirationCardValue: undefined,
			inputsError: [],
			isOpenAddCardForm: false,
			paymentMethodSelected: undefined,
			showError: false,
			typeCard: undefined,
			userNameValue: undefined
		});
	}


	return (
		<ClaroModalCustom isOpen={props.isOpen} backgroundColor={props.backgroundColor}>
			<ClaroCardSimple
				backgroundColor={props.addCardFormData.isOpenAddCardForm ? "#ffffff" : "#f6f6f6"}
				borderRadius='15px 15px 0px 0px'
				margin='0px'
				height={props.height}
				style={{ width:"100%",	position: "fixed", bottom: "0px" }}
				fadeIn={props.fadeIn}
                fadeInTime={props.fadeInTime}
                cubicBezier={props.cubicBezier}
                addCloseEfect = {props.addCloseEfect}>
				
				{/* Back and close buttons */}
				<div style={{ height: '20px', width: '100%' }}>
					{
						props.addCardFormData.isOpenAddCardForm &&
						<img 
							style={{ float: 'left' }}
							src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_scr_ct_card_form_back.png`}
							width="24px"
							height="24px"
							onClick={
								() => {
									cleanAddCardFormData(),
									sendTaggeoBack()
								}
							} />
					}
					
					<img 
						style={{ float: 'right' }}
						src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_src_ct_alerts_close.png`}
						width="24px"
						height="24px"
						onClick={
							() => {
								props.handleCloseSelectCardAnonimous(), 
								cleanAddCardFormData(),
								sendTaggeoClose()
							}
						} />
				</div>

				{
					!props.addCardFormData.isOpenAddCardForm &&
					<PaymentMethodsList {...props} />
				}

				{
					props.addCardFormData.isOpenAddCardForm &&
					<AddCardForm {...props} />
				}

			</ClaroCardSimple>
		</ClaroModalCustom>
	)
}

const mapStateToProps = (state) => {
    const { payments } = state;
	const addCardFormData = payments.addCardFormData;

    return {
		addCardFormData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setAddCardFormData,
			executeTaggeo
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectCardAnonimous)
